import classNames from "classnames";
import styles from "./styles.module.scss";

interface TextProps {
  text: string | undefined
  className?: string
}

const LargeText = ({text, className}: TextProps) => {
  return <p className={classNames(className, styles.largeText, styles.text)}>{text ?? ""}</p>
}

const FirstTitleText = ({text, className}: TextProps) => {
  return <p className={classNames(className, styles.firstText, styles.text)}>{text ?? ""}</p>
}

const SecondTitleText = ({text, className}: TextProps) => {
  return <p className={classNames(className, styles.secondText, styles.text)}>{text ?? ""}</p>
}

const HeadlineTitleText = ({text, className}: TextProps) => {
  return <p className={classNames(className, styles.headlineText, styles.text)}>{text ?? ""}</p>
}

const BodyTitleText = ({text, className}: TextProps) => {
  return <p className={classNames(className, styles.bodyText, styles.text)}>{text ?? ""}</p>
}

const PrimaryButtonText = ({text, className}: TextProps) => {
  return <p className={classNames(className, styles.primaryButtonText, styles.text)}>{text ?? ""}</p>
}

const SubheadText = ({text, className}: TextProps) => {
  return <p className={classNames(className, styles.subheadText, styles.text)}>{text ?? ""}</p>
}

const CalloutText = ({text, className}: TextProps) => {
  return <p className={classNames(className, styles.calloutText, styles.text)}>{text ?? ""}</p>
}

const FootnoteText = ({text, className}: TextProps) => {
  return <p className={classNames(className, styles.footnoteText, styles.text)}>{text ?? ""}</p>
}


export {
  LargeText,
  FirstTitleText,
  SecondTitleText,
  HeadlineTitleText,
  BodyTitleText,
  PrimaryButtonText,
  SubheadText,
  CalloutText,
  FootnoteText
}